import FadeIn from "@/components/FadeIn";

const PHOTOS = [
  {
    src: "/clim-salon.webp",
    alt: "Unité murale Daikin dans un salon lumineux",
    caption: "Unité murale Daikin, intégrée au salon",
    tag: "Intérieur",
    className: "sm:col-span-2 sm:row-span-2 aspect-[4/3] sm:aspect-auto",
  },
  {
    src: "/clim-exterieur.webp",
    alt: "Groupe extérieur Daikin sur une maison en pierre en Gironde",
    caption: "Groupe extérieur sur maison en pierre, Gironde",
    tag: "Extérieur",
    className: "aspect-[4/3]",
  },
  {
    src: "/clim-pose.webp",
    alt: "Technicien installant une unité murale Daikin",
    caption: "Pose soignée par nos techniciens",
    tag: "Installation",
    className: "aspect-[4/3]",
  },
  {
    src: "/clim-famille.webp",
    alt: "Famille détendue sous une climatisation Daikin",
    caption: "Confort silencieux pour toute la famille",
    tag: "Confort",
    className: "sm:col-span-2 aspect-[16/7]",
  },
];

export default function ClimGallery() {
  return (
    <section
      id="realisations"
      data-testid="clim-section-realisations"
      className="bg-white py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <FadeIn>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-ice sm:text-xs">
                Nos installations
              </p>
              <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight text-ink sm:text-5xl">
                Du travail propre, dedans comme dehors.
              </h2>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-slate-500">
              Liaisons frigorifiques dissimulées, goulottes alignées, réglages
              faits avec vous : nos poses se voient à peine, se ressentent
              tout de suite.
            </p>
          </div>
        </FadeIn>

        <div className="mt-12 grid gap-4 sm:grid-cols-3 sm:grid-rows-2">
          {PHOTOS.map((p, i) => (
            <FadeIn key={p.src} delay={i * 0.08} className={p.className}>
              <figure
                data-testid={`clim-gallery-item-${i}`}
                className="group relative h-full w-full overflow-hidden rounded-3xl bg-glacier"
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent opacity-80 transition-opacity group-hover:opacity-100" />
                <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-ice backdrop-blur">
                  {p.tag}
                </span>
                <figcaption className="absolute bottom-4 left-4 right-4 font-display text-sm font-bold text-white sm:text-base">
                  {p.caption}
                </figcaption>
              </figure>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
